export default [
  {
    title: 'Highway Hunt',
    iconDisplay: 'highWayHunt',
    opts: {
      externalUrl: 'https://highwayhunt.cdllife.com/',
    },
  },
  {
    title: 'Trip Planner',
    iconDisplay: 'tripPlanner',
    opts: {
      tab: 2,
      page: 'PlanARoutePage',
      params: {
        mode: 'activeTrip',
      },
    },
  },
  {
    title: 'Places',
    iconDisplay: 'places',
    opts: {
      tab: 2,
      page: 'PlanARoutePage',
      params: {
        mode: 'allPlaces',
      },
    },
  },
  {
    title: 'Weather',
    iconDisplay: 'weather',
    opts: {
      tab: 2,
      page: 'WeatherPage',
    },
  },
  {
    title: 'Roadside Assistance',
    iconDisplay: 'roadSideAssistance',
    opts: {
      tab: 2,
      page: 'WreckersFeedPage',
    },
  },
  {
    title: 'Freight Factoring',
    iconDisplay: 'freightFactoring',
    opts: {
      tab: 2,
      page: 'FreightFactoringPage',
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/services-dashboard/default-services.ts